class CandidateProfileActionsModalController {
    constructor(documentService) {
        this.documentService = documentService;
    }
    $onInit() {
        this.actionType = this.resolve.actionType;
        this.actionLabel = this.resolve.actionLabel;
        this.candidateId = this.resolve.candidateId;
        this.folder = this.resolve.folder;
        this.document = this.resolve.document;
        this.parentFolderName = this.resolve.parentFolderName;
        this.parentFolders = this.resolve.parentFolders;
        this.showUpload = this.resolve.showUpload;
        this.documents = this.resolve.documents;
        this.availableDocuments = this.resolve.availableDocuments;
        this.folders = this.resolve.folders;
        this.candidateJobMatchFolders = this.resolve.candidateJobMatchFolders;
        this.candidateDetails = this.resolve.candidateDetails;
        this.candidateType = this.resolve.candidateType;
        this.deleteDocumentPayload = this.resolve.deleteDocumentPayload;
        this.allFoldersList = this.resolve.allFoldersList;
        this.isSharedDocumentActionAvailable = this.resolve.isSharedDocumentActionAvailable;
        this.companiesToShareCandidateDocuments = this.resolve.companiesToShareCandidateDocuments;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.sourceScreen = this.resolve.sourceScreen;
        this.formalizeActivityPayload = this.resolve.formalizeActivityPayload;
        this._setCandidateDocumentViewUrl();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
    refresh(folder) {
        this.callbackObject.callbackType = 'refresh';
        if (folder) {
            this.callbackObject.entity = folder;
            this.closeModal();
        }
    }
    attachDocuments(documents) {
        this.callbackObject.callbackType = 'attachDocuments';
        this.callbackObject.entity = documents;
        this.closeModal();
    }
    onEmployeeAdded(employee) {
        this.modalInstance.close(employee);
    }
    _setCandidateDocumentViewUrl() {
        if (this.document) {
            if (this.document.isJobMatchDocument) {
                this.documentViewUrl = this.document.link;
            }
            else {
                this.documentViewUrl = this.documentService.getCandidateDocumentReportUrl(this.document.id);
            }
        }
    }
}
CandidateProfileActionsModalController.$inject = ['documentService'];
// import * as TEMPLATE from './candidate-profile-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./candidate-profile-actions-modal.html';
export const CandidateProfileActionsModalComponent = {
    selector: 'candidateProfileActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CandidateProfileActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateProfileActionsModal/candidate-profile-actions-modal.html'
    }
};
//# sourceMappingURL=candidate-profile-actions-modal.component.js.map